import Cal from "@calcom/embed-react";
import Link from "next/link";
import BaseLayout from "@/components/base-layout";
import BrandCloud from "@/components/brand-cloud";
import { Header } from "@/components/header";
import FAQSection from "@/components/sections/faq";

const BookADemoPage = () => {
  return (
    <BaseLayout>
      <Header
        canonical="https://promptwatch.com/book-a-demo"
        title="Book a demo | Promptwatch.com"
        description="Book a demo with Promptwatch to learn how to boost your brand visibility in LLMs"
      />
      <main className="overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-b from-blue-200/50 via-blue-100/50" />
        <div
          aria-hidden="true"
          className="absolute h-full w-full scale-[0.8] bg-[radial-gradient(#e5e7eb_1px,transparent_1px)] [background-size:16px_16px] [mask-image:radial-gradient(ellipse_50%_50%_at_50%_50%,#fff_70%,transparent_100%)]"
        />

        <section className="relative border-b border-gray-950/[0.07]" id="platform">
          <div className="relative mx-auto max-w-6xl border-x border-gray-950/[0.07] px-4 sm:px-6 md:px-12">
            <div aria-hidden="true" className="bg-ui absolute -bottom-1 -left-1 size-2 border shadow-sm z-40" />
            <div aria-hidden="true" className="bg-ui absolute -bottom-1 left-3 size-2 border shadow-sm sm:left-5 md:left-11 z-40" />
            <div aria-hidden="true" className="bg-ui absolute -bottom-1 -right-1 size-2 border shadow-sm z-40" />
            <div aria-hidden="true" className="bg-ui absolute -bottom-1 right-3 size-2 border shadow-sm sm:right-5 md:right-11 z-40" />
            <div className="relative border-x border-gray-950/[0.07]">
              <nav aria-label="Breadcrumb" className="p-3">
                <ol className="flex items-center text-sm">
                  <li>
                    <Link href="/" className="text-primary hover:underline">
                      Home
                    </Link>
                  </li>
                  <li className="mx-2 text-muted-foreground">/</li>
                  <li className="text-gray-700" aria-current="page">
                    Book a demo
                  </li>
                </ol>
              </nav>
            </div>
          </div>
        </section>

        <section className="relative border-b">
          <div className="relative mx-auto max-w-6xl border-x border-gray-950/[0.07] px-4 sm:px-6 md:px-12">
            <div aria-hidden="true" className="bg-ui absolute -bottom-1 -left-1 size-2 border shadow-sm" />
            <div aria-hidden="true" className="bg-ui absolute -bottom-1 left-3 size-2 border shadow-sm sm:left-5 md:left-11" />
            <div aria-hidden="true" className="bg-ui absolute -bottom-1 -right-1 size-2 border shadow-sm" />
            <div aria-hidden="true" className="bg-ui absolute -bottom-1 right-3 size-2 border shadow-sm sm:right-5 md:right-11" />
            <div className="relative border-x border-gray-950/[0.07] bg-white">
              <header className="px-5 sm:px-20 pt-16">
                <h1 className="text-title text-4xl font-semibold mb-2">Book a Promptwatch demo</h1>
                <h2 className="flex items-center text-sm text-muted-foreground mb-4 max-w-md">
                  Get personalized walkthrough of the Promptwatch platform, setup your account and get your first insights.
                </h2>
              </header>

              <div className="px-5 sm:px-20 py-12">
                <Cal calLink="gijs-de-groot-ufxgwx/promptwatch15min" config={{ theme: "light" }} />
              </div>
            </div>
          </div>
        </section>
        <section className="border-b">
          <div className="mx-auto max-w-6xl border-x px-3 py-10">
            <div className="p-10 px-0 z-10 relative">
              <h3 className="text-body text-center text-sm font-medium">Promptwatch is trusted by 500+ Companies</h3>
              <BrandCloud />
            </div>
          </div>
        </section>

        <section className="relative border-b overflow-hidden border-gray-950/[0.07]">
          <div className="relative mx-auto max-w-6xl border-x border-gray-950/[0.07] px-4 sm:px-6 md:px-12">
            <div aria-hidden="true" className="bg-ui absolute -bottom-1 -left-1 size-2 border shadow-sm z-40" />
            <div aria-hidden="true" className="bg-ui absolute -bottom-1 left-3 size-2 border shadow-sm sm:left-5 md:left-11 z-40" />
            <div aria-hidden="true" className="bg-ui absolute -bottom-1 -right-1 size-2 border shadow-sm z-40" />
            <div aria-hidden="true" className="bg-ui absolute -bottom-1 right-3 size-2 border shadow-sm sm:right-5 md:right-11 z-40" />
            <div className="relative border-x border-gray-950/[0.07] px-4 pb-16 pt-16 sm:px-12">
              <FAQSection />
            </div>
          </div>
        </section>
      </main>
    </BaseLayout>
  );
};

export default BookADemoPage;
